var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wc-loaders-cube wc-loader-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"wc-loader-shadow"}),_c('div',{staticClass:"wc-loader-animate",style:(_vm.animateStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }